export const MixedCargoIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none">
      <g filter="url(#filter0_d_4039_827)">
        <path
          d="M35.75 20.5C35.75 28.9223 28.9223 35.75 20.5 35.75C12.0777 35.75 5.25 28.9223 5.25 20.5C5.25 12.0777 12.0777 5.25 20.5 5.25C28.9223 5.25 35.75 12.0777 35.75 20.5Z"
          fill="#E5EAF0"
          stroke="white"
          strokeWidth="2.5"
        />
        <path
          d="M20.4692 12.2507C20.0039 12.2314 19.6172 12.6031 19.6189 13.0691C19.6209 13.5354 20.0093 13.9108 20.4764 13.8951C23.1498 13.9044 25.5603 15.5207 26.5932 17.9945C27.6249 20.4677 27.0723 23.3022 25.1883 25.1862C24.8549 25.5028 24.8481 26.0354 25.177 26.3644C25.5052 26.6926 26.0375 26.6879 26.3544 26.3542C28.7034 24.0052 29.3987 20.4557 28.1114 17.3712C26.8244 14.2849 23.8045 12.264 20.4692 12.2507Z"
          fill="#5A6C81"
        />
        <path
          d="M28.2935 26.9152C28.5881 26.5927 28.5768 26.095 28.2682 25.7864L25.595 23.1132C25.0889 22.6088 24.2257 22.9519 24.2033 23.6658L24.124 26.4164C24.1121 26.8851 24.4952 27.2683 24.963 27.2554L27.714 27.18C27.9346 27.1734 28.1444 27.0775 28.2935 26.9152Z"
          fill="#5A6C81"
        />
        <path
          d="M20.5305 28.7474C20.9974 28.7669 21.3831 28.3959 21.3824 27.9291C21.3795 27.462 20.991 27.0882 20.5249 27.1032C17.8515 27.0939 15.4401 25.4767 14.4072 23.0028C13.3742 20.5288 13.9283 17.695 15.812 15.8113C16.1588 15.496 16.1699 14.9537 15.8361 14.62C15.5034 14.2873 14.9608 14.2983 14.6458 14.6452C12.2958 16.9931 11.6016 20.5436 12.8889 23.6282C14.1771 26.7132 17.1959 28.7352 20.5305 28.7474Z"
          fill="#5A6C81"
        />
        <path
          d="M12.6213 14.1702C12.3259 14.4936 12.3362 14.9901 12.6466 15.299L15.3191 17.9715C15.8252 18.4759 16.6893 18.1337 16.7111 17.4185L16.7901 14.6679C16.8031 14.1999 16.4201 13.817 15.9511 13.8289L13.2007 13.9059C12.9802 13.912 12.7704 14.0079 12.6213 14.1702Z"
          fill="#5A6C81"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4039_827"
          x="0"
          y="0"
          width="41"
          height="41"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4039_827" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4039_827"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
